import { values, indexBy, prop, sortBy } from 'ramda';
import { createSelector } from 'reselect';

import { getPlants } from '../api';
import logger from '../utils/logger';

import { reactorSelector } from './reactors';

export const PLANTS_LOAD_ACTION = 'PLANTS_LOAD_ACTION';
export const PLANTS_RECEIVE_ACTION = 'PLANTS_RECEIVE_ACTION';

function loadPlantsAction() {
  return { type: PLANTS_LOAD_ACTION };
}

function receivePlantsAction({ data, errors }) {
  return { type: PLANTS_RECEIVE_ACTION, data, errors };
}

export function loadAllPlants() {
  return function dispatchLoadAllPlants(dispatch) {
    dispatch(loadPlantsAction());
    return getPlants()
      .then(data =>
        dispatch(
          receivePlantsAction({
            data: indexBy(prop('id'), data),
          }),
        ),
      )
      .catch(
        errors =>
          logger.error('Failed to load plants:', errors) ||
          dispatch(receivePlantsAction({ errors })),
      );
  };
}

const initialState = {
  loading: false,
  loaded: false,
  errors: null,
  data: {},
};

function plantsReducer(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case PLANTS_LOAD_ACTION:
      return { ...state, loading: true };
    case PLANTS_RECEIVE_ACTION:
      return {
        ...state,
        loading: false,
        loaded: !action.errors,
        errors: action.errors || null,
        data: action.data || {},
      };
    default:
      return state;
  }
}

export function plantsLoadedSelector(state) {
  return state.plants?.loaded || false;
}

// Base selectors
const getPlantsData = state => state.plants?.data || {};
const getReactorsData = state => state.reactors?.data || {};
const getReactorsState = state => state.reactors;

// Simple memoized selector for plants with reactors
export const plantsSelector = createSelector(
  [getPlantsData, (state, { date }) => date],
  (plantsData, date) => {
    return values(plantsData).map(plant => {
      // We'll populate reactors in the component level to avoid circular deps
      return plant;
    });
  },
);

// Memoized selector for getting a single plant
export const plantSelector = createSelector(
  [getPlantsData, (state, { plantId }) => plantId],
  (plantsData, plantId) => {
    return plantsData[plantId] || null;
  },
);

export default plantsReducer;
